import { useDispatch } from 'react-redux';

import { openInNewTab } from '@app/redux/utils';

import AppleStoreSVG from './assets/apple';

import styles from './styles.module.scss';

export const AppleAppStoreButton = ({ url }: { url: string }): JSX.Element => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(openInNewTab(url));
  };

  return (
    <button onClick={onClick} data-cy="apple-app-store-button" className={styles['appStoreButton']}>
      <AppleStoreSVG />
    </button>
  );
};

export default AppleAppStoreButton;
